import { dataLongVideo } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLongVideo = /*#__PURE__*/createIcon(dataLongVideo)
export default IconLongVideo
